"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KojakScanMetadataModelToJSON = exports.KojakScanMetadataModelFromJSONTyped = exports.KojakScanMetadataModelFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function KojakScanMetadataModelFromJSON(json) {
    return KojakScanMetadataModelFromJSONTyped(json, false);
}
exports.KojakScanMetadataModelFromJSON = KojakScanMetadataModelFromJSON;
function KojakScanMetadataModelFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'score': json['score'],
        'resolutionX': json['resolution_x'],
        'resolutionY': json['resolution_y'],
        'pitch': json['pitch'],
        'height': json['height'],
        'width': json['width'],
        'position': !runtime_1.exists(json, 'position') ? undefined : (json['position'].map(_1.PositionModelFromJSON)),
    };
}
exports.KojakScanMetadataModelFromJSONTyped = KojakScanMetadataModelFromJSONTyped;
function KojakScanMetadataModelToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'score': value.score,
        'resolution_x': value.resolutionX,
        'resolution_y': value.resolutionY,
        'pitch': value.pitch,
        'height': value.height,
        'width': value.width,
        'position': value.position === undefined ? undefined : (value.position.map(_1.PositionModelToJSON)),
    };
}
exports.KojakScanMetadataModelToJSON = KojakScanMetadataModelToJSON;
//# sourceMappingURL=KojakScanMetadataModel.js.map